var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Requested"] = "REQUESTED";
    InvoiceStatus["Pending"] = "PENDING";
    InvoiceStatus["Approved"] = "APPROVED";
    InvoiceStatus["Declined"] = "DECLINED";
})(InvoiceStatus || (InvoiceStatus = {}));
export default InvoiceStatus;
